export default "__VITE_ASSET__3TS62_ky__"